module.exports = {
  // 接口地址
  apiUrl: process.env.VUE_APP_API_URL,
  // 网站地址
  hostUrl: process.env.VUE_APP_HOST_URL,
  // 文件上传
  uploadUrl: process.env.VUE_APP_API_URL + '/api/file/Uploader/',
  uploadUrl2: process.env.VUE_APP_API_URL + '/api/file/Uploader2/',
  // 文件预览
  previewApiUrl: process.env.VUE_APP_API_URL + '/api/file/Preview?fileName=',
  // nginx文件预览
  previewNginxUrl: process.env.VUE_APP_NGINX_URL,
}
